if (!customElements.get('volvik-benefits-carousel')) {
  customElements.define(
    'volvik-benefits-carousel',
    class VolvikBenefitsCarousel extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.volvik-benefits-bar__item'));
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.delay = Math.max(1000, Number(this.dataset.autoplay) || 5000);
        this.index = 0;

        this.onScroll = window.debounce?.(() => this.updateIndex(), 80) || (() => this.updateIndex());
        this.onInteractionStart = () => this.stop();
        this.onInteractionEnd = () => this.start(true);
        this.onBreakpointChange = () => this.start();
        this.onVisibilityChange = () => {
          if (document.hidden) this.stop();
          else this.start(true);
        };

        this.addEventListener('scroll', this.onScroll, { passive: true });
        this.addEventListener('pointerdown', this.onInteractionStart, { passive: true });
        this.addEventListener('pointerup', this.onInteractionEnd, { passive: true });
        this.addEventListener('pointercancel', this.onInteractionEnd, { passive: true });
        this.mobileQuery.addEventListener?.('change', this.onBreakpointChange);
        document.addEventListener('visibilitychange', this.onVisibilityChange);

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        this.removeEventListener('scroll', this.onScroll);
        this.removeEventListener('pointerdown', this.onInteractionStart);
        this.removeEventListener('pointerup', this.onInteractionEnd);
        this.removeEventListener('pointercancel', this.onInteractionEnd);
        this.mobileQuery?.removeEventListener?.('change', this.onBreakpointChange);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
      }

      updateIndex() {
        if (!this.items?.length) return;
        this.index = this.items.reduce((closestIndex, item, itemIndex) => {
          const closestDistance = Math.abs(this.items[closestIndex].offsetLeft - this.scrollLeft);
          const itemDistance = Math.abs(item.offsetLeft - this.scrollLeft);
          return itemDistance < closestDistance ? itemIndex : closestIndex;
        }, 0);
      }

      start(reset = false) {
        this.stop();
        if (!this.mobileQuery?.matches || this.items.length < 2 || document.hidden) return;
        if (reset) this.updateIndex();
        this.timer = window.setInterval(() => this.advance(), this.delay);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      advance() {
        this.index = (this.index + 1) % this.items.length;
        this.scrollTo({ left: this.items[this.index].offsetLeft, behavior: 'smooth' });
      }
    }
  );
}
